/**
 * Service de gestion des utilisateurs
 * Centralise tous les appels API liés aux utilisateurs
 */
import apiService from './api.service';

class UserService {
  /**
   * Obtenir tous les utilisateurs créés
   */
  async getAllUsers() {
    return await apiService.get('utilisateur/all');
  }

  /**
   * Obtenir tous les rôles
   */
  async getAllRoles() {
    return await apiService.get('role/all');
  }

  /**
   * Obtenir les fonctionnalités par rôle utilisateur
   */
  async getFunctionalitiesByUserRole(roleCode) {
    return await apiService.get(`fonctionnalite/role/${roleCode}`);
  }

  /**
   * Obtenir les fonctionnalités par rôle
   */
  async getFunctionalitiesByRole(roleId) {
    return await apiService.get(`fonctionnalite/role/${roleId}`);
  }

  /**
   * Créer un utilisateur
   */
  async createUser(userData) {
    return await apiService.post('utilisateur', userData);
  }

  /**
   * Mettre à jour un utilisateur
   */
  async updateUser(userId, userData) {
    return await apiService.put(`utilisateur/${userId}`, userData);
  }

  /**
   * Supprimer un utilisateur
   */
  async deleteUser(userId) {
    return await apiService.delete(`utilisateur/${userId}`);
  }

  /**
   * Obtenir le profil utilisateur
   */
  async getUserProfile(userId) {
    return await apiService.get(`utilisateur/${userId}`);
  }

  /**
   * Changer le mot de passe
   */
  async changePassword(userId, passwordData) {
    return await apiService.put(`utilisateur/${userId}/password`, passwordData);
  }

  /**
   * Obtenir l'URL de la photo de profil
   */
  async getProfilePhotoUrl(userId) {
    return await apiService.get(`document/photo-profil/${userId}`);
  }
}

export default new UserService();
